import { createContext } from "react";
import type {
  ActivatedTestsType,
  AdobeScript,
} from "./target-api-provider.type";

export interface TargeApiProviderContextType {
  activatedTests: ActivatedTestsType;
  sendTargetAPI(adobe: AdobeScript): void;
}

export const TargetApiProviderContext =
  createContext<TargeApiProviderContextType>({
    activatedTests: {},
    sendTargetAPI: () => {},
  });
